/* Czarina — panier : ajout sans quitter la page + protection des pièces « Price upon request » */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast;
  function showToast(msg, withLink) {
    toast = toast || document.getElementById('cz-toast');
    if (!toast) return;
    toast.querySelector('.cz-toast__msg').textContent = msg;
    var link = toast.querySelector('a');
    if (link) link.style.display = withLink === false ? 'none' : '';
    toast.classList.add('is-on');
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.classList.remove('is-on'); }, 5200);
  }
  function updateCount(cart) {
    document.dispatchEvent(new CustomEvent('cz:cart-updated', { detail: { count: cart.item_count } }));
  }

  /* Les pièces à 0 € sont des objets sur demande : elles ne peuvent jamais rester dans le panier */
  function purgeOnRequest() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var removed = [];
        cart.items.forEach(function (it) { if (Number(it.final_price) === 0) { updates[it.key] = 0; removed.push(it.product_title); } });
        if (!removed.length) return cart;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); }).then(function (c) {
          showToast(removed.join(', ') + ' — price upon request. Please contact us.', false);
          if (/\/cart(\/|$|\?)/.test(location.pathname)) setTimeout(function () { location.reload(); }, 1600);
          return c;
        });
      })
      .then(updateCount)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cz-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        var items = item.items || [item];
        if (items.some(function (i) { return Number(i.final_price) === 0; })) return purgeOnRequest().then(function () { throw { description: 'This piece is priced upon request — please contact us.' }; });
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { updateCount(cart); showToast('Added to your bag'); })
      .catch(function (err) { showToast((err && err.description) || 'Sorry, this piece could not be added', false); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', purgeOnRequest); else purgeOnRequest();
})();
